import React from 'react';

import { SelectableList } from './SelectableList';

interface RecipientsProps {
  mode: 'view' | 'edit';
  recipients: string[];
  onRecipientsChange?: (recipients: string[]) => void;
  availableEmails?: string[];
}

export function Recipients({
  mode,
  recipients,
  onRecipientsChange,
  availableEmails = [],
}: RecipientsProps) {
  const isEdit = mode === 'edit';

  return (
    <SelectableList
      mode={mode}
      title="Recipients"
      selectedItems={recipients}
      availableItems={availableEmails}
      onSelectionChange={onRecipientsChange}
      caption={
        isEdit
          ? 'This alert sends in-app notifications to all users. Select users who should also receive email notifications.'
          : (count) => `${count} user${count === 1 ? '' : 's'} will be notified`
      }
      emptyStateMessage="No email found"
      searchPlaceholder="Search"
      width="30rem"
    />
  );
}
